import styled from "styled-components";

export const Container = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem 2.5rem;
  width: 42.5rem;

  p {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
    text-align: center;
  }

  p {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.5em;
  font-weight: 700;
  justify-content: center;
  margin-top: 2rem;
  min-height: 5.6rem;
  width: 32.4rem;

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const CancelButton = styled.button`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #002e6c;
  border: none;
  box-shadow: 0px 10px 20px #f4f4f4;
  box-sizing: border-box;
  color: #002e6c;
  cursor: pointer;
  display: flex;
  font-size: 1.5em;
  font-size: 15px;
  font-weight: 700;
  justify-content: center;
  margin-top: 2rem;
  min-height: 5.6rem;
  width: 32.4rem;

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
